module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABHNCSVQICAgIfAhkiAAAAStJREFUOE9jZACC////ZwIpYyBOY2Rk/AcSwweA6kOA8hFAHA1U/5MRKFAB5LRDNc0D0qn4DIIasByojgWI9wKxP8iQBiCjHslmnAahGQDScgSIPRmh3iFoEE4DGBm/gA0hZBA+A0B64YbgMWgHUG4ZNAwQXgC6AOYAFENwGPQfyTJIGCAZgOESPF7D6gKcLoG6xgNIbwViJqRYmwp0QQ4SH87E5h2QAeuBmAOLhglAgwrRxdEDFt0AUBhcBOJsJI0YBiFHMboB54Aa7UGBCIzifiC7AJdBsMSGzQBXoAHvkAIbp0GgZE/QAEIGgQxZCVQUBlUI8gKKC9ADEc1rj4DyZiBDQLlxARBrEjIAzUXeQL4L0MuPYGECovmAAh+xpQNsYkDLBYDqP4DkAPWNnDe/7ciiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_close.png
// module id = bENg
// module chunks = 17